import { Slot, usePathname } from 'expo-router';
import { useEffect, useRef } from 'react';
import { Platform, ScrollView, StyleSheet, View } from 'react-native';

import { Footer, PrimaryNav, UtilityBar } from '@/components/layout';
import { useTheme } from '@/theme';

export default function PublicLayout() {
  const theme = useTheme();
  const pathname = usePathname();
  const scrollRef = useRef<ScrollView>(null);

  // Reset scroll on route change.
  useEffect(() => {
    scrollRef.current?.scrollTo({ y: 0, animated: false });
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [pathname]);

  return (
    <ScrollView
      ref={scrollRef}
      style={{ backgroundColor: theme.colors.bg }}
      contentContainerStyle={styles.scroll}
      showsVerticalScrollIndicator={false}
    >
      <UtilityBar />
      <PrimaryNav />
      <View style={styles.body}>
        <Slot />
      </View>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scroll: { flexGrow: 1 },
  body: { flexGrow: 1 },
});
